module.exports = __webpack_public_path__ + "static/media/JP_RB_EYELASHES04.80278885.jpg";